<script setup lang="ts">
    import type { PageProps } from '~/@types/generic';

    const props = defineProps<PageProps>();

    const { breadcrumbItems, breadcrumbVisibility, page } = usePage(props);

    const nuxtApp = useNuxtApp();
    const cartStore = useCartStore();

    const { setBaseData } = useMicroDataStore();
    setBaseData({ type: page.value?.base?.content_type?.[0], dateModified: props.pageData.system.lastModified });

    onMounted(() => {
        cartStore.cartReadyHook(() => nuxtApp.$gtm.ecommerceContentPage(page.value));
    });
</script>

<template>
    <div class="page content-grid">
        <lazy-atm-breadcrumbs
            v-if="breadcrumbItems.length"
            :items="breadcrumbItems"
            :visibility="breadcrumbVisibility" />

        <cms-content-controller
            v-if="isContent(page.content)"
            :data="page.content"
            is-content-page
            class="page-controller content-grid" />
    </div>
</template>
